import { useEffect, useRef, useState } from 'react';
import { recoveryApi } from '../services/recoveryApi';
import type { Claim } from '../types/LegalCase';

// Pretensão ATUAL do caso, só leitura, para seções que dependem dos títulos mas não os editam
// (Pagamentos, e o abatimento em Depósitos).
//
// Por que não usar o `detail.claim` do page-view: ele é o retrato de quando a página abriu. A
// seção Pretensão mantém estado próprio, então um título cadastrado nela nesta sessão não chega
// ao retrato — e o seletor de título das outras seções ficava vazio (achado na validação da
// AF-3816). As seções remontam ao trocar de aba, então buscar no mount basta para ver o atual.
//
// `refreshKey` (AF-3995): a seção que muda o que a pretensão projeta (lançar ou remover pagamento
// mexe nos totais por origem) troca a chave para reler. A releitura não volta ao retrato do
// page-view no meio do caminho: só a troca de caso reinicia o estado.
export default function useCurrentClaim(
    caseId: string | null,
    initialClaim?: Claim | null,
    refreshKey = 0,
) {
    const [claim, setClaim] = useState<Claim | null>(initialClaim || null);
    const fetchGenRef = useRef(0);
    const seededCaseRef = useRef<string | null>(null);

    useEffect(() => {
        if (!caseId) return;
        const generation = ++fetchGenRef.current;
        if (seededCaseRef.current !== caseId) {
            seededCaseRef.current = caseId;
            setClaim(initialClaim || null);
        }
        recoveryApi
            .getClaim(caseId)
            .then((result) => {
                if (fetchGenRef.current === generation) setClaim(result.claim || null);
            })
            .catch(() => {
                // silencioso — fica com o retrato do page-view
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [caseId, refreshKey]);

    return claim;
}
